export const DEFAULT_CORE_NETWORK_UI_CONFIG = {
  workRequestsLabel: "Work Requests",
  talentLabel: "Talent",
  matchesEnabled: true,
};

export const CORE_NETWORK_UI_CONFIG_UPDATED_EVENT = "core-network-ui-config-updated";

function normalizeString(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

export function normalizeCoreNetworkUiConfig(value = null) {
  const source =
    value && typeof value === "object" && !Array.isArray(value)
      ? value.settings && typeof value.settings === "object" && !Array.isArray(value.settings)
        ? value.settings
        : value
      : {};

  return {
    workRequestsLabel:
      normalizeString(source.workRequestsLabel) ||
      DEFAULT_CORE_NETWORK_UI_CONFIG.workRequestsLabel,
    talentLabel:
      normalizeString(source.talentLabel) ||
      DEFAULT_CORE_NETWORK_UI_CONFIG.talentLabel,
    matchesEnabled:
      Object.prototype.hasOwnProperty.call(source, "matchesEnabled")
        ? source.matchesEnabled !== false
        : DEFAULT_CORE_NETWORK_UI_CONFIG.matchesEnabled,
  };
}

export function emitCoreNetworkUiConfigUpdated(uiConfig) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(CORE_NETWORK_UI_CONFIG_UPDATED_EVENT, {
      detail: normalizeCoreNetworkUiConfig(uiConfig),
    })
  );
}
